import React from 'react';

class CTABonus3 extends React.Component {
  render() {
    return (
      <div className="container-fluid justify-content-center CTA">
        <h2>EXPLORE THE STATS AND REAP THE BENEFITS</h2>
      </div>
    )
  }
}
export default CTABonus3;
